/**
 * Phase 3 — Auto loan lender rate table.
 *
 * Thin vertical wrapper around the shared `<PartnerRateTable />`
 * engine. Accepts `category="auto-loan"` (default) or
 * `category="refinance"` so the iter-196.QQ purpose-filter chips on
 * the homepage can swap to the refi catalog without remounting a
 * different component.
 *
 * Iter-196.RR — Added `compactHeader` passthrough so the homepage
 * editorial wrapper can suppress the inner table's redundant H2 +
 * subtitle + MethodologyBadge (which now duplicate the wrapper's own
 * CompactRubricStrip).
 */
import React from "react";
import PartnerRateTable from "../PartnerRateTable";
import { AUTO_LOAN_CONFIG } from "../../features/auto-loans/config";

export default function AutoLoanLenderTable({
  category = "auto-loan",
  sourcePage,
  title,
  subtitle,
  limit = 10,
  creditMax,
  creditMin,
  onListChange,
  enableFilters = false,
  compactHeader = false,
  suppressMethodologyBadge = false,
}) {
  return (
    <div data-testid="auto-loan-lender-table">
      <PartnerRateTable
        category={category}
        sourcePage={sourcePage}
        title={title || AUTO_LOAN_CONFIG.rateTable.headerLabel}
        subtitle={subtitle}
        limit={limit}
        creditMax={creditMax}
        creditMin={creditMin}
        onListChange={onListChange}
        enableFilters={enableFilters}
        compactHeader={compactHeader}
        suppressMethodologyBadge={suppressMethodologyBadge}
      />
    </div>
  );
}
